import { render } from "./Page.vue?vue&type=template&id=741d9e70&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import "./Page.vue?vue&type=style&index=0&id=741d9e70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-741d9e70"],['__file',"src/scripts/view/portfolio/Page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "741d9e70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('741d9e70', __exports__)) {
    api.reload('741d9e70', __exports__)
  }
  
  module.hot.accept("./Page.vue?vue&type=template&id=741d9e70&scoped=true", () => {
    api.rerender('741d9e70', render)
  })

}


export default __exports__